export default __webpack_public_path__ + "bml-consult64c300.png";